import type { EngineService } from './registry.js';

/**
 * The staging region Vinz reserves. It has two roles, so changing it changes both:
 * - it names the reserved region: in every message, in the deploy-job matcher, in discovery's
 *   workspace suffix and in the `VINZ_RESERVED_EXCLUDE` value;
 * - it is the one deploy target of a Serverless/CDK service. Those deploy a region, not a terraform
 *   workspace, so the region itself stands in where an ECS service has its workspace names, and it
 *   keys their observation and `HIST#` rows (a change re-keys those rows, as it does the ECS ones).
 */
export const RESERVED_REGION = 'us-west-2';

/**
 * What a service's rows are keyed by: its ECS workspaces in the reserved region, or the region for a
 * Serverless/CDK service. Nothing for a service with no shared deploy workflow - there is no deploy to read.
 */
export function deployTargets(service: Pick<EngineService, 'path' | 'westWorkspaces'>): readonly string[] {
  if (service.westWorkspaces.length > 0) return service.westWorkspaces;
  return service.path === 'cdk' || service.path === 'serverless' ? [RESERVED_REGION] : [];
}
